
import XHeader from 'vux/src/components/x-header/index.vue'
import DatetimeView from 'vux/src/components/datetime-view/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {
components: {
XHeader,
DatetimeView,
XButton
},
directives: {
TransferDom
},
data() {
return {
examDate: "",
examDay: "",
format: "YYYY-MM-DD"
};
},
created() {
if (this.$store.getters.getUserInfo != undefined) {
this.$http({
method: "post",
url: "wxexam.ashx?op=GetExamDate",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
courseId: this.$store.getters.getClassInfo.CourseId
}
})
.then(response => {
if (response.status == 200) {
if (response.data.errcode == 0) {
this.changeValue(response.data.data);
}
}
})
.catch(function(error) {
console.log("error:" + error);
});
}
},
methods: {
changeValue(val) {
this.examDate = val;
this.$refs.datetime.render();
},
onChangeDate() {},
dateDiff(sDate1, sDate2) {
if (sDate1 == "" || sDate2 == "") {
return 0;
}

var aDate, oDate1, oDate2, iDays;
oDate1 = new Date(sDate1);
oDate2 = new Date(sDate2);
iDays = Math.ceil((oDate2 - oDate1) / 1000 / 60 / 60 / 24);
return iDays < 0 ? 0 : iDays;
},
saveExamDate() {
this.$http({
method: "post",
url: "wxexam.ashx?op=SetExamDate",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
courseId: this.$store.getters.getClassInfo.CourseId,
date: this.examDate
}
})
.then(response => {
if (response.status == 200) {
if (response.data.errcode == 0) {
this.$vux.toast.text("设置考试时间成功", "bottom");
} else {
this.$vux.toast.text(response.data.errmsg, "bottom");
}
}
})
.catch(function(error) {
console.log("error:" + error);
});
}
}
};



// WEBPACK FOOTER //
// ./src/components/ExamDate.vue